import { GLOBALTYPES } from '../actions/globalTypes';


const initialState = {
  isHydrated: false,
};

const authReducer = (state = initialState, action) => {
    switch (action.type) {
      case GLOBALTYPES.AUTH:
        return { ...action.payload, isHydrated: true };
      default:
        return state;
    }
}

export default authReducer;